// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkOperationStatusSchema = z.enum(['PENDING','RUNNING','STOPPED','COMPLETED','FAILED'] as const);

export type InternalNetworkOperationStatusType = `${z.infer<typeof InternalNetworkOperationStatusSchema>}`

export default InternalNetworkOperationStatusSchema;
